
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component({})
  export default class PhoneInput extends Vue {
    @Prop() value: string;
    @Prop() clearable!: boolean;
    @Prop() disabled!: boolean;
    @Prop() placeholder!: string;
    @Prop() size!: string;

    $refs: any;
    bufferValue = '';
    bufferIteration = 0;
    isPasting = false;

    setPhonePrefix() {
      if (!this.value) {
        this.$emit('input', '+7 (');
        const input = this.$refs.phoneInput.$refs.input;
        setTimeout(() => input.setSelectionRange(4, 4), 0);
      }
    }

    removePhonePrefix() {
      if (this.value === '+7 (') this.$emit('input', '');
    }

    onPaste(event: ClipboardEvent) {
      event.preventDefault();
      event.stopPropagation();

      const clipboardData = event.clipboardData || (window as any).clipboardData;
      const pastedText = clipboardData.getData('text/plain');

      // Очищаем от всех нецифровых символов
      let cleaned = pastedText.replace(/\D/g, '');

      if (!cleaned) return;

      // Если номер начинается с 8, заменяем на 7
      if (cleaned.length >= 11 && cleaned[0] === '8') {
        cleaned = '7' + cleaned.slice(1);
      }

      // Если номер начинается с 7, оставляем как есть
      // Если начинается с другой цифры - добавляем 7
      if (cleaned.length > 0 && cleaned[0] !== '7') {
        cleaned = '7' + cleaned;
      }

      // Обрезаем до 11 цифр (7 + 10 цифр)
      if (cleaned.length > 11) {
        cleaned = cleaned.slice(0, 11);
      }

      // Формируем номер с префиксом +7
      let formatted = '+7 (';
      if (cleaned.length > 1) {
        const digits = cleaned.slice(1); // убираем первую 7
        formatted += digits.slice(0, 3);
        if (digits.length > 3) {
          formatted += ') ' + digits.slice(3, 6);
        }
        if (digits.length > 6) {
          formatted += ' ' + digits.slice(6, 8);
        }
        if (digits.length > 8) {
          formatted += ' ' + digits.slice(8, 10);
        }
      } else {
        formatted = '+7 (';
      }

      // Устанавливаем флаг, что идет вставка
      this.isPasting = true;

      // Обновляем значение
      this.$emit('input', formatted);

      // Устанавливаем курсор в конец
      const input = this.$refs.phoneInput.$refs.input;
      setTimeout(() => {
        const len = formatted.length;
        input.setSelectionRange(len, len);
        this.isPasting = false;
      }, 0);
    }

    phoneInputAction(value) {
      if (this.isPasting) return;
      let needReplace = false;

      if (value.length === 11 && value[0] === '8') {
        this.bufferValue = value.replace('8', '+7');
        needReplace = true;
      }

      let maskToChange = ['+7 (8', '+7 (7', '+7 (+7'];
      let usedMask = '';
      for (let maskStr of maskToChange) {
        if (value.includes(maskStr)) {
          usedMask = maskStr;
          break;
        }
      }
      if ([15, 16].includes(value.length) && usedMask) {
        this.bufferValue = value.replace(usedMask, '+7');
        needReplace = true;
      }

      if (value[4] === '8') needReplace = true;

      if (needReplace) value = value.replace('8', '');

      if (this.bufferValue) {
        this.bufferIteration++;
      }

      if (this.bufferIteration === 2) {
        value = this.bufferValue;
        this.bufferIteration = 0;
        this.bufferValue = '';
      }

      this.$emit('input', value);
    }
  }
